module.exports = __webpack_public_path__ + "img/xxpgcp.d8ed7806.png";